module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "download": _vm.downloadName,
      "href": _vm.downloadUrl,
      "disabled": this.data.length === 0
    }
  }, [_vm._t("default", [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-280801e5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-280801e5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CsvDownload.vue
// module id = 2
// module chunks = 0